import api from "../../../../../api"
import attrs from "../../../../../api/attrs"
import Reference_API from "./api"
import Vue from "vue"

class Reference_controller
{
    constructor(self, group_id, id, data, not_editable = false)
    {
        this.self = self
        this.group_id = group_id
        this.id = id
        this.data = data
        this.not_editable = not_editable
        this.api = new Reference_API(self, group_id, id)

        if (process.env.NODE_ENV !== 'production') {
            console.log({ reference : data })
        }

        this._init()
    }

    _init()
    {
        this.bus = new Vue()

        this._get_stat()

        attrs.get(this.self).then((res) => {
            this.attrs = res.attrs
            this.bus.$emit("attrs_ready")
            this.area_attr_id = this.attrs.find((attr) => attr.key == "attrs.Area").id
        })
    }

    _update_data()
    {
        this.api.get_reference_data().then((data) => {
            if (process.env.NODE_ENV !== 'production') {
                console.log({reference : data})
            }
            this.data = data
            this.bus.$emit("data_updated")
        })
    }

    async _get_objects(key, value)
    {
        const params = {
            query : JSON.stringify({ "and" : [
                { keys : [ "cadastral_group" ], operation : "cadastral_group", args : [ this.group_id ]},
                { keys : [ key ], operation : "eqs", args : [ value ]},
            ]})
        }

        const objects = await this.api.get_objects(params)

        return objects
    }

    _get_stat()
    {
        return new Promise((resolve) => {
            if (this.stat && this.calc_stat)
            {
                resolve({ stat : this.stat, calc_stat : this.calc_stat })
            }
            else
            {
                Promise.all([

                    new Promise((resolve) =>
                        Promise.all(this.data.factors.map((attr_id) => this.api.get_statistics(attr_id)))
                            .then(resolve)
                    ),
            
                    new Promise((resolve) =>
                        Promise.all(this.data.calc_factors.map((attr_id) => this.api.get_statistics(attr_id)))
                            .then(resolve)
                    )

                ]).then(([ stat, calc_stat ]) => {
                    this.stat = stat
                    this.calc_stat = calc_stat
                    resolve({ stat, calc_stat })

                    this.bus.$emit("stat_loaded")
                })
            }
        })
    }

    check_roles(roles)
    {
        return this.api.check_roles(roles)
    }

    async set_field(key, value)
    {
        const keys = key.split(".")

        const _data = api.deep_clone(this.data)

        let obj = _data

        while(keys.length > 0)
        {
            if (keys.length === 1)
            {
                obj[keys.shift()] = value
            }
            else
            {
                obj = obj[keys.shift()]
            }
        }
        
        this.data = _data

        await this.api.set_field(key, value)

        this.bus.$emit("data_updated")

        if (process.env.NODE_ENV !== 'production') {
            console.log({reference_data : this.data})
        }

        return this.data
    }

    async _add_factor(attr_id, key)
    {
        const attr_ids = [ ...this.data[key], attr_id ]
        
        await this.set_field(key, attr_ids)

        const attr_stat = await this.api.get_statistics(attr_id)
        if (key == "factors") { this.stat.push(attr_stat) }
        else { this.calc_stat.push(attr_stat) }

        this.bus.$emit("stat_loaded")

        return attr_ids
        
    }

    async _delete_factor(attr_id, key)
    {
        const attr_ids = this.data[key].filter((_attr_id) => _attr_id != attr_id)

        await this.set_field(key, attr_ids)

        if (key == "factors") { this.stat = this.stat.filter(({ id }) => id != attr_id) }
        else { this.calc_stat = this.calc_stat.filter(({ id }) => id != attr_id) }

        this.bus.$emit("stat_loaded")

        return attr_ids
    }

    set_stat(callback)
    {
        if (!this._set_stat_callback)
        {
            this._set_stat_callback = callback

            this.bus.$on("stat_loaded", () => this._set_stat_callback({
                stat : this.stat,
                calc_stat : this.calc_stat
            }))

            if (this.stat && this.calc_stat)
            {
                this._set_stat_callback({
                    stat : this.stat,
                    calc_stat : this.calc_stat
                })
            }
                    
        }
        else
        {
            this._set_stat_callback = callback

            this._set_stat_callback({
                stat : this.stat,
                calc_stat : this.calc_stat
            })
        }
    }

    //#region Settings

    async add_factor(attr_id)
    {
        const attr_ids = [ ...this.data.factors, attr_id ]

        const is_exist = await this._check_factors(attr_ids)

        if (is_exist)
        {
            this.data.calc_factors.includes(attr_id) && this.delete_calc_factor(attr_id, false)

            const attr_ids = await this._add_factor(attr_id, "factors")
            await this._add_predicted(attr_id)

            this._calculate_deviation()

            return attr_ids
        }
        else
        {
            this.self.$bvModal.msgBoxOk(
                "Отсутствует хотя бы один объект оценки со значением данного ЦОФ",
                {
                    okVariant : "danger",
                    hideHeaderClose : false,
                    centered : true
                }
            )
        }
    }

    async delete_factor(attr_id)
    {
        const attr_ids = await this._delete_factor(attr_id, "factors")

        await this._delete_predicted(attr_id)

        await this.delete_attr_correction({ attr_id })

        this._calculate_deviation()

        return attr_ids
    }

    _check_factors(attr_ids)
    {
        const params = {
            query : JSON.stringify({ "and" : [

                { keys : [ "cadastral_group" ], operation : "cadastral_group", args : [ this.group_id ]},

                ...attr_ids.map((attr_id) => ({
                    keys : [ 'current_version.' + this.attrs.find((attr) => attr.id == attr_id).key ],
                    operation : "notempty", args : []
                }))

            ]}),
        }

        return new Promise((resolve) => {
            api.call(this, "cadastral_objects", "get_many", params, ({ data: objects }) => { resolve(objects.length > 0) })
        })

    }

    async object_by_cad_num(cad_num)
    {
        const objects = await this._get_objects("current_version.attrs.CadastralNumber", cad_num)
        
        return objects
    }

    async change_selection_type(value)
    {
        await this.set_field("selection_type", value)

        this._calculate_deviation()
    }

    async _calculate_deviation()
    {
        if (this.data.selection_type == "Поиск")
        {
            await this.api.calculate_deviation()

            this.bus.$emit("update_deviation")
        }
    }

    _get_elements_attrs()
    {
        if (this.data.factors.length == 0)
        {
            return
        }

        const _attrs = [
            {
                label : "",
                key : "options",
                visible : true,
                visible_if_no_visible : true,
                thStyle: "width: 64px;",
                params : true,
            },
            {
                key : "",
                attr_key : "attrs.CadastralNumber",
                visible : true,
                visible_if_no_visible : true,
            },
            {
                key : "system.reference_weighted",
                label : "Отклонение от средневзвешенного значения",
                visible : true,
                visible_if_no_visible : true,
                sortable : true,
                head_params : true,
            },
        ]

        this.data.factors.forEach((id) => {
            const _attr = this.attrs.find((attr) => attr.id == id)

            if (_attr)
            {
                _attrs.push(
                {
                    key : "",
                    attr_key : _attr.key,
                    visible : true,
                    visible_if_no_visible : true,
                })
            }
        })
        
        return _attrs
    }

    set_elements_attrs(callback)
    {
        if (!this._set_elements_attrs_callback)
        {
            this._set_elements_attrs_callback = callback

            if (!this.attrs)
            {
                this.bus.$on("attrs_ready", () => this._set_elements_attrs_callback(this._get_elements_attrs()))
            }
            else
            {
                this._set_elements_attrs_callback(this._get_elements_attrs())
            }
    
            this.bus.$on("update_deviation", () => this._set_elements_attrs_callback(this._get_elements_attrs()))
        }
        else
        {
            this._set_elements_attrs_callback = callback

            this._set_elements_attrs_callback(this._get_elements_attrs())
        }
    }

    async _add_predicted(attr_id)
    {
        if (!this.attrs) {
            await new Promise((resolve) => this.bus.$on("attrs_ready", () => resolve()))
        }

        if (this.area_attr_id != attr_id)
        {
            this.data.predicted = [...this.data.predicted, { id : attr_id }]
            await this.set_field("predicted", this.data.predicted)
            this._update_data()
        }
    }

    async _delete_predicted(attr_id)
    {
        if (!this.attrs) {
            await new Promise((resolve) => this.bus.$on("attrs_ready", () => resolve()))
        }

        if (this.area_attr_id != attr_id)
        {    
            this.data.predicted = this.data.predicted.filter(({ id }) => id != attr_id)
            this.set_field("predicted", this.data.predicted)
        }
    }

    set_predicted(callback)
    {
        if (!this._set_predicted_callback)
        {
            this._set_predicted_callback = callback

            this.bus.$on("data_updated", () => this._set_predicted_callback(this.data.predicted))

            this._set_predicted_callback(this.data.predicted)

        }
        else
        {
            this._set_predicted_callback = callback

            this._set_predicted_callback(this.data.predicted)
        }
    }

    //#endregion

    //#region Sales

    async add_calc_factor(attr_id)
    {
        const result = await this._add_factor(attr_id, "calc_factors")

        this.bus.$emit("update_analogues_corrections")

        return result
    }

    async delete_calc_factor(attr_id, delete_from_calc_corrections=true)
    {
        const attr_ids = await this._delete_factor(attr_id, "calc_factors")

        if (delete_from_calc_corrections)
        {
            await this.delete_attr_correction({ attr_id })
        }
        
        return attr_ids
    }

    async _get_hypothetical_obj(attrs)
    {
        const stats = await Promise.all(attrs.map(({ id }) => this.api.get_statistics(id)))

        const _object = {}

        const _attrs = attrs.reduce((obj, attr) => ({ ...obj, [attr.id] : attr.key }), {})

        stats.forEach(({ id, objects : { weighted_average } }) => {
            const custom = this.data.predicted.find(({ id : custom_id, current_value }) => custom_id == id && current_value != null)

            const value = custom ? custom.current_value : _object[id] = weighted_average

            _attrs[id] == "attrs.Area" ? _object.area = value : _object[id] = value
        })

        return _object
    }

    _get_obj_values(attrs, obj)
    {
        const _object = {}

        attrs.forEach(({ id, key }) => {
            if (key == "attrs.Area")
            {
                _object.area = api.get_obj_value(obj.current_version, key)
            }
            else
            {
                _object[id] = api.get_obj_value(obj.current_version, key)
            }
        })

        return _object
    }

    async _get_ref_obj(attrs)
    {
        if (this.data.selection_type)
        {
            if (this.data.selection_type == "По кадастровому номеру" && this.data.cad_num?.value)
            {
                const result = await this.api.get_obj_by("current_version.attrs.CadastralNumber", this.data.cad_num?.value)

                if (result)
                {
                    return this._get_obj_values(attrs, result)
                }
            }
            else if (this.data.selection_type == "Поиск" && this.data.search_object_id)
            {
                const result = await this.api.get_obj_by("id", this.data.search_object_id)

                if (result)
                {
                    return this._get_obj_values(attrs, result)
                }
            }
            else if (this.data.selection_type == "Гипотетический")
            {
                return await this._get_hypothetical_obj(attrs)
            }
        }
    }

    async get_analogues_corrections()
    {
        const fields = [
            { label : "", key : "settings", tdClass : "is_settings", thClass : "text-center", thStyle: "min-width: 64px;", },
            { label : "Наименование ЦОФ", key : "name" },
        ]

        const attrs_ids = [ ...this.data.factors, ...this.data.calc_factors ]

        if (!this.attrs) {
            await new Promise((resolve) => this.bus.$on("attrs_ready", () => resolve()))
        }

        const attr_area = this.attrs.find((attr) => attr.key == "attrs.Area")
        const keys = [ attr_area.key ]
        attrs_ids.forEach((id) => {
            const attr = this.attrs.find((attr) => attr.id == id)

            if (attr) { keys.push(attr.key) }
        })

        const { corrections, analogues, uprs_average } = await this.api.get_analogues_corrections(keys)

        if (process.env.NODE_ENV !== 'production') {
            console.log({get_analogues_corrections: {corrections, analogues, uprs_average}})
        }

        const _items = {}
        const _corrections = []
        const showed_attrs = new Set()
        const attrs_keys = []

        corrections.forEach((correction) => {
            const _attr = this.attrs.find((_attr) => _attr.id == correction.name)

            if (_attr)
            {
                _items[correction.name] = { ...correction, factor : _attr, values : {}, corrections : {}, uprs : {} }
                _corrections.push({ id : correction.name, order : correction.order, is_attr : true })
                showed_attrs.add(correction.name)
                attrs_keys.push({ id : correction.name, key : _attr.key })
            }
            else
            {
                _items[correction.name] = { ...correction, values : {}, corrections : {}, uprs : {} }
                _corrections.push({ id : correction.name, order : correction.order })
            }
        })

        // ################## ref_obj #########################

        attrs_keys.push({ id : attr_area.id, key : attr_area.key  })

        const ref_obj = await this._get_ref_obj(attrs_keys)
        if (process.env.NODE_ENV !== 'production') {
            console.log({ref_obj})
        }

        const attrs = Array.from(new Set(attrs_ids).difference(showed_attrs))

        if (ref_obj)
        {
            fields.push({ label : "Типовой (эталонный) объект недвижимости", key : "ref_obj" })

            _corrections.forEach(({ id, is_attr }) => {

                if (is_attr)
                {
                    if (id == attr_area.id)
                    {
                        _items[id].values.ref_obj = ref_obj.area
                    }
                    else
                    {
                        const _item = _items[id]
    
                        if (_item.factor)
                        {
                            _items[id].values.ref_obj = _item.factor.reference ? api.format_reference(_item.factor.reference, ref_obj[id]) : ref_obj[id]
                        }
                    }
                }
            })
        }

        // ################## fields #########################

        _corrections.sort((a, b) => a.order - b.order)

        const uprs_item = {
            name : `Скорректированный удельный показатель цены, руб./${ api.has_oks() ? 'ед. изм.' : 'кв.м' }`,
            is_attr: true, is_uprs : true
        }

        api.sort_objects_array_by_key(analogues, "group_code")

        analogues.forEach((object) => {
            fields.push({ label : object.group_code, key : object.id, bad : object.bad })

            const analogues_corrections = object.corrections.reduce((obj, correction) => ({ ...obj, [correction.name] : correction }), {})

            _corrections.forEach(({ id, is_attr }, index) => {
                const _item = _items[id]
                const factor = analogues_corrections[id]

                if (is_attr)
                {
                    _item.values[object.id] = _item.factor.reference ? api.format_reference(_item.factor.reference, factor.value) : factor.value
                }
                _item.corrections[object.id] = factor.correction

                const prev_index = index - 1
                _item.uprs[object.id] = prev_index >= 0
                    ? _items[_corrections[prev_index].id].uprs[object.id] * factor.correction
                    : object.uprs * factor.correction
            })

            uprs_item[object.id] = object.uprs
        })

        // ################## items #########################

        const items = [ uprs_item ]

        _corrections.forEach(({ id, order, is_attr }) => {
            const item = _items[id]
            if (is_attr)
            {
                items.push(
                    { id, order, name : item.factor.name, ...item.values, is_attr: true },
                    { id, order, name: "Корректировка", ...item.corrections, is_correction: true },
                    { id, order, name: "Скорректированный удельный показатель цены с учетом корректировки по ЦОФ, руб./кв. м", ...item.uprs },
                )
            }
            else
            {
                items.push(
                    { id, order, name: item.name, ...item.corrections, is_attr: true, is_correction: true },
                    { id, order, name: "Скорректированный удельный показатель цены с учетом корректировки по ЦОФ, руб./кв. м", ...item.uprs },
                )
            }
        })

        this.data.calc_UPKS = uprs_average

        return { fields, items, attrs, uprs_average, last_order : _corrections.length ? _corrections[_corrections.length-1].order : -1, ref_obj, analogues_count : analogues.length }
    }

    set_analogues_corrections(callback)
    {
        if (!this._set_analogues_corrections_callback)
        {
            this._set_analogues_corrections_callback = callback

            if (!this.attrs)
            {
                this.bus.$on("attrs_ready", () => this._set_analogues_corrections_callback())
            }
            else
            {
                this._set_analogues_corrections_callback()
            }

            this.bus.$on("update_analogues_corrections", () => this._set_analogues_corrections_callback())
        }
        else
        {
            this._set_analogues_corrections_callback = callback

            this._set_analogues_corrections_callback()
        }
    }

    async add_attr_correction(value)
    {
        await this.api.add_correction(value)

        this.bus.$emit("update_analogues_corrections")
    }

    async delete_attr_correction(value)
    {
        await this.api.unset_correction_many(value.attr_id ? value.attr_id : value.name)
        await this.api.delete_correction(value)

        this.bus.$emit("update_analogues_corrections")
    }

    async set_correction(id, correction_id, value)
    {
        await this.api.set_correction(id, correction_id, value)

        this.bus.$emit("update_analogues_corrections")
    }

    //#endregion
}

export default Reference_controller
